import { Component, h, Host, Prop } from "@stencil/core";

@Component({
    tag: "ux-chat-date-divider",
    styleUrl: "chat-date-divider.scss",
    shadow: false
})
export class ChatDateDivider {
    /**
     * The text to display in the date divider
     */
    @Prop() readonly text!: string;

    render() {
        return (
            <Host role="separator" aria-label={this.text}>
                <div class="date-divider">
                    <ux-copy variant="tiny">{this.text}</ux-copy>
                </div>
            </Host>
        );
    }
}
